import { greyDarkWithOpacity } from "@/angelouCE/utils/constants";
import { sharedOptionCss } from "../ActionsDropdown.style";

export const buttonItemCss = (isSelected) => [
  {
    ...sharedOptionCss,
    backgroundColor: isSelected && greyDarkWithOpacity,
    height: "40px",
    "&:focus-visible:not([disabled])::before": {
      backgroundColor: "transparent",
      opacity: "1",
    },
  },
];
